export const PARTNER_ADDED_FROM = {
  ADMIN: 'admin',
  WEBSITE: 'website',
};

export const normalizePartnerAddedFrom = (value) => {
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase();
  if (normalized === PARTNER_ADDED_FROM.ADMIN) return PARTNER_ADDED_FROM.ADMIN;
  if (normalized === PARTNER_ADDED_FROM.WEBSITE) return PARTNER_ADDED_FROM.WEBSITE;
  return null;
};

export const getPartnerAddedFromLabel = (value) => {
  const normalized = normalizePartnerAddedFrom(value);
  if (normalized === PARTNER_ADDED_FROM.ADMIN) return 'Admin';
  if (normalized === PARTNER_ADDED_FROM.WEBSITE) return 'Website';
  return null;
};

export const PARTNER_ADDED_FROM_STYLES = {
  [PARTNER_ADDED_FROM.ADMIN]: {
    chipBackgroundColor: 'rgba(25, 118, 210, 0.12)',
    chipColor: '#1976d2',
  },
  [PARTNER_ADDED_FROM.WEBSITE]: {
    chipBackgroundColor: 'rgba(123, 31, 162, 0.12)',
    chipColor: '#7b1fa2',
  },
};
